/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import type { BoxProps } from '../Box/Box';
import Box from '../Box/Box';
import Typography from '../Typography/Typography';

export type Props = BoxProps & {
  title?: string;
  subtitle?: string;
};

const LayoutContentHeader: React.FC<Props> = ({
  title,
  subtitle,
  sx,
  children,
  ...boxProps
}) => (
  <Box
    className="LayoutContent-Header"
    sx={{
      width: '100%',
      padding: '2 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      /*
       * & > *:not(:last-child) is the better selector but seems
       * like its not supported on IE11.
       */
      '& > *': {
        marginBottom: '1',
      },
      '& > *:last-child': {
        marginBottom: '0',
      },
      ...(sx as any),
    }}
    {...boxProps}
  >
    {title && (
      <Box>
        <Typography
          as="h2"
          color="title"
          align="center"
          variant="body"
          weight="bold"
        >
          {title}
        </Typography>
      </Box>
    )}
    {subtitle && (
      <Box>
        <Typography
          color="light"
          as="h2"
          align="center"
          variant="caption"
          weight="normal"
        >
          {subtitle}
        </Typography>
      </Box>
    )}
    {children}
  </Box>
);

export default LayoutContentHeader;
